<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'customerManage-brand',
  components: {
    PageTable
  }
}
</script>
